import { Box, Header } from '@rbilabs/universal-components';

export const InformationTitle = Header.withConfig({
  variant: 'headerFour',
  fontSize: '16px',
  lineHeight: 'lg',
});

export const NutritionInformationWrapper = Box.withConfig({
  paddingX: { base: 4, md: 0 },
});

export const NutritionInformationContainer = Box.withConfig({
  marginY: {
    base: '$2',
    md: '$6',
  },
});
